import { bootstrapApplication } from "@angular/platform-browser";
import { createAppConfig, RootComponent } from "@dcc/vestas-online/feat-root";
import { APP_CONFIG, APP_CONFIG_URL } from "@dcc/vestas-online/domain";
import { VoAppConfig } from "@dcc/vestas-online/domain";

// V8 records only 10 frames by default, which framework internals usually fill
// before reaching application code; deeper stacks make telemetry traceable.
Object.assign(Error, { stackTraceLimit: 50 });

fetch(APP_CONFIG_URL)
    .then((response) => response.json())
    .then((config: VoAppConfig) => {
        bootstrapApplication(RootComponent, {
            providers: [{ provide: APP_CONFIG, useValue: config }, ...createAppConfig(config).providers]
        }).catch((err) => console.log(err));
    });
